import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Navigate } from 'react-router-dom'

import PageTitle from 'components/atoms/PageTitle'
import PageLoading from 'components/atoms/PageLoading'

import useSession from 'hooks/useSession'

export default function Sessions() {
  const { t } = useTranslation()

  const { isFetching, fetchCurrentAssignmentSession, session } = useSession()

  useEffect(() => {
    fetchCurrentAssignmentSession()
  }, [fetchCurrentAssignmentSession])

  return (
    <div className="content-container">
      {isFetching || !Object.keys(session).length ? (
        <PageLoading />
      ) : session?.sessionId ? (
        <Navigate to={`/assignment/${session.sessionId}`} />
      ) : (
        <>
          <PageTitle label={t('assignment.title')} />
          {t('assignment.emptyContent')}
        </>
      )}
    </div>
  )
}
